import React, { Suspense, useEffect } from "react"
import { RouteFallback } from "components/new-stuff/layout/RouteFallback"
import { Alert, App, Layout } from "antd"
import { useState } from "react"
import { useAuthStore } from "stores"
import { Navigate, Outlet, useNavigate } from "react-router-dom"
import { SideNavigationBar } from "./SideNavigationBar"
import { TopNavigationBar } from "./TopNavigationBar"
import { NotificationBar } from "./NotificationBar"
// import { isPadeDomain } from "utils/utils"
import { useGet } from "utils/useFetch"
import { IEarningsWalletData } from "pages/employee-dashboard/wallet/interface/wallet"
import { InformationCircleIcon } from "@heroicons/react/24/outline"
import { mixPanelEvent } from "components/new-stuff/mix-panel/MixPanel"
import { useHubspotChat } from "hooks/useHbspt/useHbspt"
import useExtendUser from "hooks/useExtendUser"
import IdleTimer from "IdleTimer"
import HandholdHelp from "components/handhold/HandholdHelp"
import { WhatsNewPopup } from "features/whats-new/WhatsNewPopup"
// import Intercom from "@intercom/messenger-js-sdk"

const { Header, Content } = Layout

const NewResponsiveEmployeeLayout: React.FC = () => {
  const { user } = useAuthStore()
  const navigate = useNavigate()
  const [isSidebarOpen, toggleSidebar] = useState(false)

  const { isAuthenticated, signOut } = useAuthStore((state) => ({
    isAuthenticated: state.isAuthenticated,
    signOut: state.signOut,
  }))

  const {
    isLoading: isEarningWalletLoading,
    data: earningWalletData,
    refetch,
  } = useGet<IEarningsWalletData>({
    instanceKey: "ewaAxiosInstance",
    url: `/v1/earnings/wallet`,
    external: true,
    retry: 0,
    enabled: user?.isEwaEnabled === true && user?.userStatusId !== 5,
  })

  useEffect(() => {
    if (!isAuthenticated) {
      signOut(true)
    }
  }, [isAuthenticated])

  useHubspotChat(process.env.REACT_APP_HUBSPOT_PORTALID || "")
  useExtendUser()

  // const intercomUser = {
  //   user_id: user?.userId,
  //   email: user?.userName,
  //   name: user?.userFullName,
  // }

  if (user?.userStatusId === 2 || user?.userStatusId === 3) {
    return <Navigate to="/employee/susp-exit/payslips" />
  }

  // isPadeDomain() === true &&
  //   Intercom({
  //     app_id: "bi604cch",
  //     user_id: user?.userId,
  //     name: user?.userFullName,
  //     email: user?.userName,
  //   })

  return (
    <App
      notification={{
        placement: "topRight",
      }}
    >
      <IdleTimer />
      <WhatsNewPopup whatsNewPath="/employee/dashboard/whats-new" />
      <HandholdHelp />
      <Layout>
        <SideNavigationBar
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
        />

        {earningWalletData
          ? user?.isEwaEnabled === true &&
            !earningWalletData?.data?.employee?.enrollmentStatus && (
              <div className="sticky top-0 z-20 md:pl-[var(--sidenav-w)] transition-[padding-left] duration-300 ease-in-out motion-reduce:transition-none font-avenir  ">
                <Alert
                  message="Set up your Earned Wage Access pin to gain access to up to 50% of your salary."
                  type="warning"
                  showIcon
                  icon={
                    <InformationCircleIcon className="h-4 w-4 lg:h-12 lg:w-12 !text-primary500" />
                  }
                  closable
                  action={
                    <div className="lg:pr-5  absolute lg:relative  bottom-2 lg:bottom-0  left-7 lg:left-0 ">
                      <button
                        onClick={() => {
                          mixPanelEvent(`empl-ewa-alert-clicked-init`)
                          navigate(
                            "/employee/dashboard/wallet/earned-wage-access/pin"
                          )
                        }}
                        className="bg-primary500 px-4 py-1 text-white rounded"
                      >
                        Set PIN
                      </button>
                    </div>
                  }
                  className="bg-[#CCDBFD] invoice-alert font-avenir text-neutral500 text-sm w-full flex justify-between items-center border-[#CCDBFD] !rounded-none"
                />
              </div>
            )
          : null}
        <Layout>
          <Header className="bg-white p-0 sticky top-0 z-10 w-full border-b md:pl-[var(--sidenav-w)] transition-[padding-left] duration-300 ease-in-out motion-reduce:transition-none h-[70px]">
            <TopNavigationBar
              isSidebarOpen={isSidebarOpen}
              toggleSidebar={toggleSidebar}
            />
          </Header>
          <Content className=" ">
            <div className="bg-[#F3F5FB] min-h-[100dvh] md:pl-[var(--sidenav-w)] transition-[padding-left] duration-300 ease-in-out motion-reduce:transition-none font-avenir employee__layout">
              <Suspense fallback={<RouteFallback />}>
                <Outlet />
              </Suspense>
              {/* <Dashboard /> */}
            </div>
          </Content>
        </Layout>
      </Layout>

      <NotificationBar />
    </App>
  )
}

export default NewResponsiveEmployeeLayout
